import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      position: 'absolute',
      top: ({ selectionRect }) =>
        selectionRect ? `calc(${selectionRect?.bottom}px - 1em)` : '20px',
      height: '1em',
      right: 0,
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
      gap: 4,
      marginTop: -3,

      pointerEvents: 'none',
      zIndex: theme.zIndex.absoluteElement,
    },
    button: {
      pointerEvents: 'auto',
      padding: 0,
      color: COLORS.gray.gray60,

      '&:hover': {
        backgroundColor: 'transparent',
        color: COLORS.gray.gray50,
      },

      '& svg': {
        fontSize: theme.typography.pxToRem(32),
      },
    },
    tooltip: {
      marginTop: theme.spacing(1),
    },
  }),
  { name: 'ContinueRowFloatingPanel' }
);
